import * as React from "react";
import {Field} from "react-final-form";

export default class NumericInput extends React.Component<NumericInputProps, any> {

    render() {
        const {name, className, placeholder, disabled} = this.props;
        return (
            <Field name={name}>
                {({input, meta}) => (
                    <div>
                        <input {...input} type={"numeric"} placeholder={placeholder} disabled={disabled}
                               className={className ? className.concat(" form-control") : "form-control"}/>
                        <div>
                            {meta.error && <span className={"text-danger"}>{meta.error}</span>}
                        </div>
                    </div>
                )}
            </Field>
        );
    }

    handleChange = (e) => {
        const re = /^[0-9\b]+$/;
        if (e.target.value === "" || re.test(e.target.value)) {
            this.setState({value: e.target.value});
        }
    };

}

interface NumericInputProps {
    name: string,
    className?: string,
    placeholder?: string,
    disabled?: boolean
}


// WEBPACK FOOTER //
// ./src/co/sura/dominio/general/componentes/NumericInput.tsx